// Libraries
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
// Components
import { unitAndRangeActions } from './unitAndRangeStore.actions';
import { initialState } from './unitAndRangeStore.state';
// Types
import { UnitAndRangeStore } from './unitAndRangeStore.types';

/**
 * Creates and configures the Unit and range store.
 */
export const useUnitAndRangeStore = create(
  immer<UnitAndRangeStore>((set) => ({
    ...initialState,
    ...unitAndRangeActions(set),
  }))
);
